<template>
  <div class="unfilledOrderMod">
    <div class="Content">
      <div class="Title">
        <h2>您有未完成的{{title}}订单</h2>
      </div>
      <div class="List">
        <div>
          <xk-record-order-mod v-for="(time, index) in data?data:null"
                               @recordOrderModClick="actionFn"
                               :key="index"
                               :startAddress="time.startAddress"
                               :endAddress="time.endAddress"
                               :serverTime="time.serverTime"
                               :status="time.status"
                               :orderId="time.orderId"
          >
          </xk-record-order-mod>
        </div>
      </div>
      <div class="closeBut" @click="modalFn">
        <span>X</span>
      </div>
    </div>
    <div class="modal" @click="modalFn"></div>
  </div>
</template>

<script>
  import XkRecordOrderMod from '../../recordOrderMod/src/recordOrderMod'

  export default {
    components: {XkRecordOrderMod},
    name: 'xk-unfilledOrderMod',
    props: ['data', 'title'],
    computed: {},
    data () {
      return {}
    },
    watch: {},
    methods: {
      actionFn: function (orderId) {
        this.$emit('click', orderId)
      },
      modalFn: function () {
        this.$emit('close')
      }
    },
    mounted: function () {
      console.log('未完成订单Mod', this.data)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .unfilledOrderMod {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 300;
    .Content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      height: 60%;
      background-color: #eee;
      border-radius: 0.333rem;
      z-index: 50;
      .Title {
        text-align: center;
        line-height: 3.5rem;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        border-radius: 0.333rem 0.333rem 0 0;
        background-color: #fff;
        h2 {
          color: #333;
        }
      }
      .List {
        box-sizing: border-box;
        width: 100%;
        height: calc(~'100% - 3.5rem');
        overflow-y: auto;
      }
      .closeBut {
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        text-align: center;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translate(-50%, 10%);
        z-index: 80;
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          color: #666;
          transform: translate(-44%, -45%);
        }
      }
    }
    .modal {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      z-index: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// unfilledOrderMod.vue?49513f38